<div class="p-4 modal-scroll overflow-hidden">
    <div class="position-relative heading-border pb-3">
        <h1 class="fw-bold m-0 heading">Add Bulk Audits</h1>
        <button type="button" class="position-absolute top-0 end-0 btn-close" aria-label="Close"
            (click)="closeModal()"><i class="bi bi-x-lg fw-bold text-white" *ngIf="!theme"></i></button>
    </div>

    <div class="overflow-content">
        <div class="mt-3">
            <div class="mx-auto col-12 mb-3 create-content-dark-card" [ngClass]="theme ? 'card': 'card dark-card' ">
                <div class="">
                    <div class="m-1">
                        <div class="row my-2">
                            <div class="position-relative col-3">
                                <label class="fw-600 fs-14 Neutral mb-1">Keyword</label>
                                <i class="bi bi-search text-primary search-icon"></i>
                                <input type="text" class="form-control input ps-56" [(ngModel)]="keyWordName"
                                    placeholder="Enter your Keyword">
                            </div>
                            <div class="col-3">
                                <label class="fw-600 fs-14 Neutral mb-1">Country</label>
                                <mat-form-field appearance="outline" class="w-100 country-input flag-input"
                                    [ngClass]="theme ? '': 'dark-input' ">
                                    <img [src]="selectedFlag !=='' ? selectedFlag : defaultFlag" alt="" width="34"
                                        height="24" class="selected-flag">
                                    <mat-select [(ngModel)]="selected" (keyup.enter)="checkEnter($event)" [disableOptionCentering]="true"
                                        panelClass="{{selectMenu}}">
                                        <div class="p-2">
                                            <input type="text" class="form-control input search-input" [(ngModel)]="key"
                                                (keyup)="searchDropDownMainData('country')" placeholder="Search ...">
                                        </div>
                                        <mat-option *ngFor="let data of mainDropDownCountry;let in = index"
                                            (click)="getSelectedMainFlag(data.code.split(':')[1],data?.country,in)"
                                            [value]="data?.country">
                                            <img loading="lazy"
                                                src="https://flagpedia.net/data/flags/normal/{{data.code.split(':')[1]}}.png"
                                                alt="" width="34" height="24">
                                            <span class="fs-16 ms-2 ps-1">{{data?.country}}</span>
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-3">
                                <label class="fw-600 fs-14 Neutral mb-1">Language</label>
                                <mat-form-field appearance="outline" class="w-100 country-input"
                                    [ngClass]="theme ? '': 'dark-input' ">
                                    <mat-select [(ngModel)]="languageType" [disableOptionCentering]="true"
                                        panelClass="{{selectMenu}}">
                                        <div class="p-2">
                                            <input type="text" class="form-control input search-input"
                                                [(ngModel)]="languageKey" placeholder="Search ..."
                                                (keyup)="searchDropDownMainData('language')">
                                        </div>
                                        <mat-option *ngFor="let data of mainLanguageDropdown"
                                            (click)="languageType===data.code"
                                            [value]="data.code">{{data.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-2">
                                <label class="fw-600 fs-14 Neutral mb-1">Device</label>
                                <mat-form-field appearance="outline" class="w-100 country-input"
                                    [ngClass]="theme ? '': 'dark-input' ">
                                    <mat-select [(ngModel)]="crawlType" [disableOptionCentering]="true">
                                        <mat-option value="Mobile">Mobile</mat-option>
                                        <mat-option value="Desktop">Desktop</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-1 d-flex justify-content-center align-items-center">
                                <i class="bi bi-plus-circle fs-20" role="button"
                                    (click)="addContent();clearMainForm()"></i>
                            </div>
                            <div class="position-relative col-12">
                                <label class="fw-600 fs-14 Neutral mb-1">Url</label>
                                <i class="bi bi-link-45deg prefix text-primary search-icon"></i>
                                <input type="text" class="form-control input ps-56" [(ngModel)]="url"
                                    placeholder="Enter your page URL ...">
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="table-div">
                <form [formGroup]="bulkAuditForm" style=" height: calc(100vh - 354px);
                overflow: auto;">
                    <ng-container formArrayName="bulkContent">
                        <table class="hover w-100" [ngClass]="theme ? '': 'dark-table' ">
                            <thead class="align-middle">
                                <tr class="table-head">
                                    <th scope="col" class="fw-500 text-gray  py-3 text-lef" style="width: 27%;">Keyword
                                    </th>
                                    <!-- <th scope="col" class="fw-500 text-gray  py-3 text-lef" style="width: 27%;" >Url</th> -->
                                    <th scope="col" class="fw-500 text-gray  py-3 text-lef" style="width: 27%;">Country
                                    </th>
                                    <th scope="col" class="fw-500 text-gray  py-3 text-lef" style="width: 27%;">Language
                                    </th>
                                    <th scope="col" class="fw-500 text-gray  py-3 text-lef" style="width: 27%;">Device
                                        Type</th>
                                    <th scope="col" class="fw-500 text-gray  py-3 text-lef" style="width: 10%;">Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="align-top Neutral dark-content">
                                <ng-container
                                    *ngIf="bulkAuditForm.controls['bulkContent']?.value?.length > 0;then recordDiv;else noRecordDiv">

                                </ng-container>
                                <ng-template #recordDiv>
                                    <ng-container *ngFor="let content of bulkContent?.controls; let i = index"
                                        [formGroup]="content">
                                        <tr style="border-bottom: 0;">

                                            <td class="pt-3 Neutral dark-content  text-left" style="width: 27%;">
                                                <div class="position-relative">
                                                    <i class="bi bi-search text-primary"></i>
                                                    <input type="text" class="form-control input ps-56"
                                                        placeholder="Enter your Keyword" formControlName="keyword">
                                                </div>
                                            </td>
                                            <!-- <td class="pt-3 Neutral dark-content  text-left" style="width: 27%;">
                                            <div class="position-relative">
                                                <i class="bi bi-search text-primary"></i>
                                                <input type="text" class="form-control input ps-56" placeholder="Enter your url"
                                                    formControlName="url">
                                            </div>
                                        </td> -->
                                            <td class="pt-3 Neutral dark-content  text-left" style="width: 27%;">
                                                <div class="">
                                                    <mat-form-field appearance="outline"
                                                        class="w-100 country-input flag-input"
                                                        [ngClass]="theme ? '': 'dark-input' ">
                                                        <!-- <img [src]="!!mainDropDownCountry[index[i]].flag && mainDropDownCountry[index[i]]?.flag !=='' ? mainDropDownCountry[index[i]]?.flag : defaultFlag" -->
                                                        <img [src]="getFlags(content.controls['location'].value)"
                                                            alt="" width="34" height="24" class="selected-flag">
                                                        <mat-select [disableOptionCentering]="true"
                                                            formControlName="location" panelClass="{{selectMenu}}">
                                                            <div class="p-2">
                                                                <input type="text"
                                                                    class="form-control input search-input"
                                                                    (keyup)="searchDropDownData($event,'country');countryIndex=i"
                                                                    placeholder="Search ...">
                                                            </div>
                                                            <ng-container
                                                                *ngIf="countryIndex==i;then searchedCountry;else defaultCountry">

                                                            </ng-container>
                                                            <ng-template #searchedCountry>
                                                                <mat-option
                                                                    *ngFor="let data of SearchedCountries;let in = index"
                                                                    (click)="getSelectedFlag(data.code.split(':')[1],data?.country,i,in)"
                                                                    [value]="data?.country">
                                                                    <img loading="lazy"
                                                                        src="https://flagpedia.net/data/flags/normal/{{data.code.split(':')[1]}}.png"
                                                                        alt="" width="34" height="24">
                                                                    <span
                                                                        class="fs-16 ms-2 ps-1">{{data?.country}}</span>
                                                                </mat-option>
                                                            </ng-template>
                                                            <ng-template #defaultCountry>
                                                                <mat-option
                                                                    *ngFor="let data of dropDownCountry;let in = index"
                                                                    (click)="getSelectedFlag(data.code.split(':')[1],data?.country,i,in)"
                                                                    [value]="data?.country">
                                                                    <img loading="lazy"
                                                                        src="https://flagpedia.net/data/flags/normal/{{data.code.split(':')[1]}}.png"
                                                                        alt="" width="34" height="24">
                                                                    <span
                                                                        class="fs-16 ms-2 ps-1">{{data?.country}}</span>
                                                                </mat-option>
                                                            </ng-template>

                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </td>
                                            <td class="pt-3 Neutral dark-content text-left" style="width: 27%;">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="w-100 country-input"
                                                        [ngClass]="theme ? '': 'dark-input' ">
                                                        <mat-select [disableOptionCentering]="true"
                                                            formControlName="language" panelClass="{{selectMenu}}">
                                                            <div class="p-2">
                                                                <input type="text"
                                                                    class="form-control input search-input"
                                                                    placeholder="Search ..."
                                                                    (keyup)="searchDropDownData($event,'language');languageIndex=i">
                                                            </div>
                                                            <ng-container
                                                                *ngIf="languageIndex==i;then searchedLanguage;else defaultLanguage">

                                                            </ng-container>
                                                            <ng-template #searchedLanguage>
                                                                <mat-option *ngFor="let data of Searchedlanguages"
                                                                    (click)="languageType===data.code"
                                                                    [value]="data.code">{{data.name}}</mat-option>
                                                            </ng-template>
                                                            <ng-template #defaultLanguage>
                                                                <mat-option *ngFor="let data of languageDropdown"
                                                                    (click)="languageType===data.code"
                                                                    [value]="data.code">{{data.name}}</mat-option>
                                                            </ng-template>

                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </td>
                                            <td class="pt-3 Neutral dark-content  text-left" style="width: 27%;">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="w-100 country-input"
                                                        [ngClass]="theme ? '': 'dark-input' ">
                                                        <mat-select [disableOptionCentering]="true"
                                                            formControlName="device">
                                                            <mat-option value="Mobile">Mobile</mat-option>
                                                            <mat-option value="Desktop">Desktop</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </td>
                                            <td class="pt-3 Neutral dark-content  text-left" style="width: 10%;">
                                                <div
                                                    class="d-flex justify-content-center align-items-center position-relative">
                                                    <i class="bi bi-dash-circle fs-20 position-absolute"
                                                        style="top: 12px;" role="button" (click)="removeContent(i)"></i>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="url-cls">
                                            <td class="pt-3 Neutral dark-content  text-left" style="width: 27%;"
                                                colspan="5">
                                                <div class="position-relative">
                                                    <i class="bi bi-link-45deg prefix text-primary url-icon"></i>
                                                    <input type="text" class="form-control input ps-56"
                                                    formControlName="url" placeholder="Enter your page URL ...">
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-container>

                                </ng-template>
                                <ng-template #noRecordDiv>
                                    <tr>
                                        <div class="no-records-div heading">
                                            Please add Audits
                                        </div>
                                    </tr>
                                </ng-template>


                            </tbody>
                        </table>
                    </ng-container>
                </form>
            </div>
        </div>
    </div>

    <div class="d-flex mt-4 justify-content-end">
        <button type="button" class="btn btn-outline-primary me-1 px-5" (click)="closeModal()">Cancel</button>
        <button type="button" class="btn btn-primary ms-1 px-5" (click)="onSubmit()"
            [disabled]="bulkAuditForm.controls['bulkContent']?.value?.length === 0">Create</button>
    </div>
</div>